// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import React from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../index'
import css from './checkQuestion.css'

type CheckQuestion = {
  id?: string
  type?: string
  description?: string
}

type Props = {
  // The question being edited, or null/undefined when creating.
  data?: CheckQuestion | null
  // The check type this question belongs to (needed when creating).
  type: string
  // Optional station scope (used by the station admin; omitted for chain admin).
  stationId?: string
  // gql mutation documents to run for create / update.
  createMutation: any
  updateMutation: any
  // Query to refetch after a successful mutation, with its variables.
  refetchQuery: any
  refetchVariables?: Record<string, any>
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}

const defaultFormData = {
  id: null,
  description: '',
}

class CheckQuestionForm extends React.Component<Props> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    if (this.props.data) {
      this.setStateFromData(this.props.data)
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { data } = this.props
    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: CheckQuestion) => {
    this.setState({ formData: { ...defaultFormData, ...data } })
  }

  onInput = (fieldName: string, newValue: string) => {
    this.setState({ formData: { ...this.state.formData, [fieldName]: newValue } })
  }

  onReset = () => {
    this.setState({ formData: { ...defaultFormData } })
  }

  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { type, stationId, onSubmit } = this.props
    const { formData } = this.state

    const variables = formData.id
      ? { id: formData.id, description: formData.description }
      : { type, description: formData.description, ...(stationId ? { stationId } : {}) }

    onMutate({ variables })
    onSubmit()
    this.onReset()
  }

  render() {
    const { data, createMutation, updateMutation, refetchQuery, refetchVariables, onCancel } = this.props
    const { formData } = this.state
    const isEditing = !!formData.id
    return (
      <Mutation
        mutation={isEditing ? updateMutation : createMutation}
        refetchQueries={[{ query: refetchQuery, variables: refetchVariables || {} }]}
      >
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.form}>
            <TextField
              autoFocus
              required
              fullWidth
              multiline
              data-testid='checkQuestionDescription'
              label={i18n.t('admin.checkQuestions.label.description')}
              value={formData.description}
              onChange={(e) => this.onInput('description', e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default CheckQuestionForm
